import React, { ChangeEvent, useState } from 'react';
import classNames from 'classnames';

import useClickOutside from 'common/useClickOutside';

import './select-input.scss';

export type option = {
  isDefault?: boolean,
  name: string,
  value: string|number
}
interface SelectInputProps {
  canEditOption?: boolean
  className?: string
  disabled?: boolean
  hideSelected?: boolean
  onChange(value: string|number): void
  options: Array<option>
  placeholder?: string
  value?: string | number | null
}

const SelectInput = ({
  canEditOption = false,
  className = '',
  disabled = false,
  hideSelected = true,
  onChange,
  options,
  placeholder = '',
  value = null,
}: SelectInputProps) => {
  const [open, setOpen] = useState(false);
  const [searchString, setSearchString] = useState<string>('');

  const toggleOpen = () => {
    setOpen((old) => !old);
  };

  const openIfClosed = () => {
    if(!open) {
      setOpen(true);
    }
  };

  const defaultOption = options[0] ?? {
    name: '',
    value: '',
  };

  const [privateValue, setPrivateValue] = useState(
    value
      ? options.filter((option) => value === option.value)[0] ?? defaultOption
      : defaultOption,
  );

  const select = (name: string, value: string|number) => {
    setPrivateValue({
      name,
      value,
    });
    onChange(value);
    toggleOpen();
  };

  const edit = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = {
      name: e.target.value,
      value: e.target.value,
    };

    setSearchString(newValue.value);
    setPrivateValue(newValue);
    onChange(newValue.value);
  };

  const longestLabel = () => {
    let length = 0;
    let finalLabel = '';

    options.forEach((option) => {
      if(option.name.length > length) {
        length = option.name.length;
        finalLabel = option.name;
      }
    });

    return finalLabel;
  };

  const ref = useClickOutside(() => {
    setOpen(false);
    setSearchString('');
  });

  return (
    <div
      ref={ref}
      className={classNames({
        [className]: className,
        disabled,
        'select-input': true,
      })}
      onClick={openIfClosed}
    >
      <div className='value'>{privateValue.name}</div>
      <div className='placeholder'>{canEditOption && open ? <input type='text' /> : longestLabel()}</div>
      <div className={classNames({
        open,
        options: true,
      })}>
        {canEditOption && open ? (
          <input type='text' value={privateValue.value} onChange={edit}
            placeholder={placeholder}
          />
        ) : privateValue.name}
        { options.filter(({ value }) => (
          value !== privateValue.value
          && `${value}`.toLowerCase().includes(searchString.toLowerCase())
        ) || !hideSelected)
          .map(({ name, value, isDefault }) => (
            <button onClick={() => {
              select(name, value);
            }} className='option' key={value}>{isDefault ? '-' : name}</button>
          )) }
      </div>
    </div>
  );
};

export default SelectInput;